import { NextResponse } from 'next/server';
import type { ApiErrorResponse } from '../interfaces/ApiErrorResponse';

/**
 * @group Functions
 * @summary <blockquote>Handles validation errors and returns a standardized error response.</blockquote>
 * @param message - Validation error message
 * @returns A NextResponse with standardized error structure
 * @example
 * ```typescript
 * if (!isValidEmail(email)) {
 *   return handleValidationError('Invalid email format');
 * }
 * ```
 */
export function handleValidationError(message: string): NextResponse<ApiErrorResponse> {
  return NextResponse.json({
    error: 'Validation error',
    details: message
  }, { status: 400 });
} 